import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-admin-contribution-categories',
  templateUrl: './admin-contribution-categories.component.html',
  styleUrls: ['./admin-contribution-categories.component.css']
})
export class AdminContributionCategoriesComponent implements OnInit {

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.setAdminPortalOpened(true);
  }

}
